import { FunctionComponent } from 'react';
import { StateDescription } from 'types/service';
import StatusIcon from 'components/service/StatusIcon';

interface Props {
  className?: string;
  option: StateDescription;
}

const SecondaryStateItem: FunctionComponent<React.PropsWithChildren<Props>> = ({
  className,
  option,
}) => {
  const classNames = ['SecondaryStateItem'];
  if (className) {
    classNames.push(className);
  }

  return (
    <div className={classNames.join(' ')}>
      <StatusIcon classNames="SecondaryStateItem-icon" stateDescription={option} />
      <span className="SecondaryStateItem-text">{option.stateName}</span>
    </div>
  );
};
export default SecondaryStateItem;
